// reselect is re-exported https://redux-toolkit.js.org/api/createSelector
// eslint-disable-next-line import/no-extraneous-dependencies
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';

// create a "selector creator" that uses lodash.isequal instead of ===
export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  isEqual,
);
